import mod from "-!./user_edit.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./user_edit.js?vue&type=script&lang=js&external"